import { render } from "./BetListCards.vue?vue&type=template&id=4eab4fad"
import script from "./BetListCards.vue?vue&type=script&lang=js"
export * from "./BetListCards.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__